
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'var(--color-primary-lighterMax)',
      color: 'var(--color-primary)',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  export default StyledTableCell;